import React from 'react';
import styled from 'styled-components';
import {Trans, useI18next} from 'gatsby-plugin-react-i18next';
import {Content} from 'components/Content';

const UTM_BY_LANGUAGE: Record<string, string> = {
  it: 'action=newsletterSignUp&utm_source=ITsite&utm_medium=banner&utm_campaign=EU+sites+banner',
  fr: 'action=newsletterSignUp&utm_source=FRsite&utm_medium=banner&utm_campaign=EU+sites+banner',
  pt: 'action=newsletterSignUp&utm_source=PTsite&utm_medium=banner&utm_campaign=EU+sites+banner',
  de: 'action=newsletterSignUp&utm_source=DEsite&utm_medium=banner&utm_campaign=EU+sites+banner'
};

const Banner = styled.div`
  background: linear-gradient(135deg, #1ea672 0%, #7b4a99 100%);
  padding: 10px 16px;
`;

const BannerContent = styled(Content)`
  display: flex;
  justify-content: center;
`;

const Text = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  text-align: center;

  a,
  strong {
    font-weight: 700;
  }

  a {
    color: #ffffff;
    text-decoration: underline;
  }
`;

export const RestrictedCountriesBanner: React.FC = () => {
  const {language} = useI18next();
  const utm = UTM_BY_LANGUAGE[language];

  if (!utm) {
    return null;
  }

  return (
    <Banner>
      <BannerContent>
        <Text>
          <Trans>
            Currently, MONEI is available only for <strong>Spain and Andorra</strong> based
            businesses. However, MONEI&apos;s global expansion is happening rapidly! To receive
            updates as soon as we become available in your country,{' '}
            <a href={`https://monei.com/subscribe/?${utm}`}>join our mailing list</a>.
          </Trans>
        </Text>
      </BannerContent>
    </Banner>
  );
};
